/** index.html malt Titel-/Objektbild schon vor React als statische „Hülle“ (#ph-hero-shell); sobald das eigene Bild gemalt ist, verschwindet sie. */
export const dropShell = () => { const s = document.getElementById("ph-hero-shell"); if (s) requestAnimationFrame(() => s.remove()); };
